<template>
    <button
        class="button"
        type="button"
        :disabled="disabled"
        @click.prevent="submitForm"
    >
        <slot />
    </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
    name: 'SubmitButton',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        action: {
            type: Number,
            default: 0,
        },
        name: {
            type: String,
            default: '',
        },
        value: {
            type: [Number, String],
            default: '',
        },
    },
    setup(props) {
        const store = useStore();

        const submitForm = (): void => {
            if (!props.name || props.value === undefined) {
                console.warn('Nieprawidłowe dane formularza.');
                return;
            }

            store.dispatch('ajax', {
                data: {
                    [props.name]: props.value,
                },
                action: props.action,
            });
        };

        return {
            submitForm,
        };
    },
});
</script>
